var lists_default = {
  "fontElementMap": "ToK39",
  "orderedlist": "_0RPyr",
  "bulletedlist": "eJ7iO",
  "listItem": "QlBGv"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
